import React, { memo } from 'react';

import { Link } from '@/components';
import { PagePath } from '@/layouts/shared';
import { TFunction } from 'next-i18next';
export type DetailBreadCrumbPartialProps = {
  categoryName: string;
  categoryCode: string;
  title: string;
  isPartner?: boolean;
  partnerId?: number;
  partnerName?: string;
  t: TFunction;
};

const BreadCrumbPartial = ({
  title,
  categoryName,
  categoryCode,
  isPartner = false,
  partnerId,
  partnerName,
  t,
}: DetailBreadCrumbPartialProps) => {
  if (isPartner) {
    return (
      <>
        <div className="tw-hidden md:tw-flex tw-gap-x-2 tw-items-center !tw-text-secondary-70 tw-text-lg">
          <Link
            className="!tw-text-secondary-70 tw-max-w hover:tw-underline hover:!tw-text-primary-main"
            url={{ pathname: PagePath.HomePage, hash: 'doi-tac-an-thu' }}
          >
            {t('detail.partner')}
          </Link>
          &nbsp;
          {partnerId && (
            <>
              {' > '}
              <Link
                className="!tw-text-secondary-70 hover:tw-underline hover:!tw-text-primary-main"
                url={{
                  pathname: PagePath.PartnerDetail,
                  query: { id: partnerId },
                }}
              >
                {partnerName}
              </Link>
            </>
          )}
          &nbsp;
          {' > '}
          <span className="!tw-text-secondary-70 tw-line-clamp-1 tw-flex-1">
            {title}
          </span>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="tw-hidden md:tw-flex tw-gap-x-2 tw-items-center !tw-text-secondary-70 tw-text-lg">
        <Link
          className="!tw-text-secondary-70 tw-max-w hover:tw-underline hover:!tw-text-primary-main"
          url={{ pathname: PagePath.ProductsPage }}
        >
          {t('detail.product')}
        </Link>
        &nbsp;
        {categoryCode && (
          <>
            {' > '}
            <Link
              className="!tw-text-secondary-70 hover:tw-underline hover:!tw-text-primary-main"
              url={{
                pathname: PagePath.CategoryPage,
                query: { id: categoryCode.toLocaleLowerCase() },
              }}
            >
              {categoryName}
            </Link>
          </>
        )}
        &nbsp;
        {' > '}
        <span className="!tw-text-secondary-70 tw-line-clamp-1 tw-flex-1">
          {title}
        </span>
      </div>
    </>
  );
};

export default memo(BreadCrumbPartial);
